import React from "react";
import { NavLink } from "react-router-dom";
import peopleData from "../components/people/data/peopleData.json";
import "../styles/PeoplePage.scss";

const People = () => {
  return (
    <main className="people-page">
      {Object.keys(peopleData).map((category) => (
        <section key={category} className="category-section">
          <h2>{category.replace(/([A-Z])/g, " $1")}</h2>
          <section className="people-list">
            {peopleData[category].map((person) => (
              <section key={person.id} className="person-card">
                <img src={person.headshot} alt={`${person.name}'s headshot`} />
                <h3>
                  <NavLink exact to={`/profile/${person.id}`}>
                    {person.name}
                  </NavLink>
                </h3>
                <p>
                  <strong>Role:</strong> {person.role}
                </p>
                <p>
                  <strong>Area of Research:</strong> {person.areaOfResearch}
                </p>
              </section>
            ))}
          </section>
        </section>
      ))}
    </main>
  );
};

export default People;
